const deleteTenantEn = {
  sectionTitle: 'Delete Tenant',
  sectionSubtitle: 'Permanently remove this tenant and all associated data',
  introPermanent: 'Deleting a tenant is',
  introIrreversible: 'permanent and irreversible',
  introSuffix: '. All tenant data will be permanently removed, including:',
  listRoles: 'Roles and role mappings',
  listUsers: 'Users and user assignments',
  listResources: 'Resources and resource configurations',
  listSessions: 'Sessions and authentication data',
  listKnowledge: 'Knowledge base and documents',
  listOther: 'All other tenant-specific data',
  requirementNote:
    'This operation can only be performed if the tenant has no cost pools and no active paid resources.',
  eligible: 'This tenant is eligible for deletion',
  notEligible: 'This tenant cannot be deleted',
  eligibilityDetails: 'Eligibility Details',
  tenantAdmin: 'Tenant admin:',
  costPools: 'Cost pools:',
  activePaidResources: 'Active paid resources:',
  blockedBecause: 'Blocked because:',
  checkEligibility: 'Check Eligibility',
  checking: 'Checking…',
  beforeCheckHint: 'Run the eligibility check first. If it passes, the permanent delete button appears here.',
  eligibleNextStep:
    'The check passed. Use the button below to delete this tenant permanently.',
  recheckEligibility: 'Run check again',
  deleteTenantCta: 'Delete this tenant permanently',
  deleteTenant: 'Delete Tenant',
  deleting: 'Deleting…',
  confirmTitle: 'Confirm Permanent Deletion',
  cannotUndone: 'This action cannot be undone',
  typeDeletePrompt: 'To confirm this permanent deletion, please type',
  typeDeleteWord: 'DELETE',
  typeDeletePromptAfter: 'in the field below.',
  placeholderDelete: 'Type DELETE to confirm',
  cancel: 'Cancel',
  deletePermanently: 'Delete Permanently',
  loadFailed: 'Failed to load cost pools',
  loadError: 'Error loading cost pools: {{message}}',
  backToTenant: 'Back to Tenant',
  costPoolsTitle: 'Cost Pools',
  loading: 'Loading…',
  loadingCostPools: 'Loading cost pools…',
  errorTitle: 'Error Loading Cost Pools',
  retry: 'Retry',
  thName: 'Name',
  thBudget: 'Budget',
  thSpent: 'Spent',
  thRemaining: 'Remaining',
  thPayment: 'Valid Payment Method',
  thActions: 'Actions',
  yes: 'Yes',
  no: 'No',
  view: 'View',
  noPoolsTitle: 'No Cost Pools Found',
  noPoolsBody: "This tenant doesn't have any cost pools yet.",
  addCostPool: 'Add Cost Pool',
};

export default deleteTenantEn;
